import DomainCollection from 'zoomforth_zf/models/domain.collection.js';

var singleton;

const init = function(data, opts) {

    singleton = new DomainCollection(data, opts);
    return singleton;
  };
const get = function() {
    if (!singleton) {
      throw new Error('You must call `init` on appglobal singleton before calling `get`');
    }
    return singleton;
  };




export { get, init };
export default { get, init };
